module.exports = __webpack_public_path__ + "img/watchpost_tech_Normal_ua.b91348a9.webp";